// extracted by mini-css-extract-plugin
module.exports = {"container":"Frame_container___ll3t","content":"Frame_content__2oMWi"};